<template>
  <div class="v-date-picker">
    <div class="pop-bg" :class="{ active: bgActive }" />
    <v-date-picker
      :key="datePickerKey"
      v-model="dateData"
      color="green"
      :first-day-of-week="2"
      :max-date="minMax?.max"
      :min-date="minMax?.min"
      :masks="masks"
      :attributes="attrs"
      :disabled-dates="{ weekdays: disableWeekdays }"
      :is-required="true"
      :mode="mode"
      is24hr
      @popoverWillShow="onOpen"
      @popoverWillHide="onClose"
    >
      <template v-if="dateData" v-slot="{ inputValue, togglePopover }">
        <div class="term-picker">
          <input
            :value="inputValue"
            :disabled="disabled"
            class="input-search__n"
            readonly
            :class="{
              overrideWidth: overrideWidth,
              dateTimeMode: dateTimeMode
            }"
            @click="togglePopover({ placement: popOverDirection })"
          />
        </div>
      </template>
      <template v-else v-slot="{ togglePopover }">
        <div class="term-picker">
          <input
            :value="null"
            :disabled="disabled"
            class="input-search__n"
            readonly
            :class="{
              overrideWidth: overrideWidth,
              dateTimeMode: dateTimeMode
            }"
            @click="togglePopover({ placement: popOverDirection })"
          />
        </div>
      </template>
    </v-date-picker>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: null
    },
    mode: {
      type: String,
      default: 'date'
    },
    minMax: {
      type: Object,
      default: () => ({ min: null, max: null })
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disableWeekdays: [],
    popOverDirection: {
      type: String,
      default: 'bottom-start'
    },
    overrideWidth: {
      type: Boolean,
      default: false
    },
    getTime: {
      type: Boolean,
      default: false
    }
  },
  // props: ['dateData', 'minMax'],

  data() {
    return {
      datePickerKey: 1000,
      dateData: null,
      dateTimeMode: false,
      bgActive: false,
      masks: {
        // input: 'YYYY-MM-DD',
        input: ['DD-MM-YYYY'],
        inputDateTime24hr: [
          'L HH:mm:ss',
          'YYYY-MM-DD HH:mm:ss',
          'YYYY/MM/DD HH:mm:ss'
        ]
      },
      attrs: [
        {
          key: 'today',
          highlight: {
            color: 'green',
            fillMode: 'outline'
          },
          dates: new Date()
        }
      ]
    }
  },
  watch: {
    dateData(data) {
      let convertedDate = null
      if (this.getTime) {
        convertedDate = this.$moment(data).format('YYYY-MM-DD HH:mm')
      } else {
        convertedDate = this.$moment(data).format('YYYY-MM-DD')
      }
      if (convertedDate === 'Invalid date') {
        convertedDate = null
      }
      this.datePickerKey++
      this.$emit('input', convertedDate)
    },
    value: {
      handler(data) {
        this.dateData = data
      },
      immediate: true
    }
  },
  mounted() {
    if (this.mode === 'datetime') {
      this.dateTimeMode = true
    }
  },
  methods: {
    onOpen() {
      this.bgActive = true
    },
    onClose() {
      this.bgActive = false
    }
  }
}
</script>

<style>
.overrideWidth {
  width: 150px !important;
}

.dateTimeMode {
  width: 180px !important;
}
</style>
